// extracted by mini-css-extract-plugin
export default {"dicardPaymentPopup":"Style_dicardPaymentPopup__2jdvW"};